// eslint-disable-next-line no-unused-vars
import { Outlet, Link } from "react-router-dom";

const Layout = () => {
  return (
    <>
      <nav></nav>
      <Outlet />
    </>
  );
};
export default Layout;
